import React from 'react'
import firebase from './firebase'
import cookie from 'react-cookies'
import { API_ENDPOINT } from './AppConfig'
import axios from 'axios'
// import ReactNotification from 'react-notifications-component'
// import { store } from 'react-notifications-component';
import { Link } from 'react-router-dom'
import 'react-notifications-component/dist/theme.css'
import NotificationSystem from 'react-notification-system';
import './App.css'

const messaging = firebase.messaging()

class FirebaseComponent extends React.Component {
    notificationSystem = React.createRef();


    constructor(props) {
        super(props);
        this.state = {
            allNotifications: [],
            NotificaationMsg: null

        }
    }
    addToken = (tokenid) => {
        let user= cookie.load("CatchItUser");
        let token_cookie = cookie.load("CatchIt_token");
        let token_sessionStorage = sessionStorage.getItem("CatchIt_token");
        let token = `Bearer ${token_cookie ? token_cookie : JSON.parse(token_sessionStorage)}`
        console.log('Token Response token000--> ', token,user)
        let data = {
            token: tokenid,
            type: "web"
        }
        axios.post(`${API_ENDPOINT}/addToken`, data, {
            headers: {
                'Content-Type': "application/json",
                Authorization: token
            }
        }).then(response => {
            console.log('Token Response data==> ', response.data.user)

        }).catch(error => {
            console.log('Token Response==>error ', error.response)
        })
    }
    addNotification = (title, msg) => {
        // event.preventDefault();
        // const notification = document.getElementById('notifi');
        const notification = this.notificationSystem.current;
        notification.addNotification({
            title: title,
            message: msg.length > 40 ? msg.substr(0, 40) + '...' : msg,
            level: 'info',
            position: 'br',
            // autoDismiss: 15000
        });
    };

    componentDidMount() {
        console.log('hello from firebase component ')
        // askForPermissioToReceiveNotifications()
        messaging.requestPermission().then(() => {
            return messaging.getToken()
        }).then(token => {
            console.log('Token notification Response: ', token)
            // addToken(token)
            cookie.save("NotificationToken", token, { path: '/' })
        }).catch((err) => {
            console.log('Token notification error: ', err);
        })

        let token_cookie = cookie.load("CatchIt_token");
        let token_sessionStorage = sessionStorage.getItem("CatchIt_token");
        console.log('token_cookie==> ', token_cookie, token_sessionStorage)

        if (token_cookie !== undefined || (JSON.stringify(token_sessionStorage) !== "null" || JSON.stringify(token_sessionStorage) !== null)) {
            let NotifiToken = cookie.load("NotificationToken")
            console.log('NotifiToken-> ', NotifiToken)
            this.addToken(NotifiToken)
        }

    }


    render() {
        messaging.onMessage((payload) => {
            console.log("Token notification payload", payload);
            this.setState({
                NotificaationMsg: payload.notification
            })
            this.addNotification(payload.notification.title, payload.notification.body)
        })

        return (
            <div>
                <Link to='/Catch-It/Notifications'>
                    <NotificationSystem ref={this.notificationSystem} id="notifi" />
                </Link>
            </div>
        )
    }
}

export default FirebaseComponent;
